import * as types from 'constants/ActionTypes';

const initReportsChangeBanner = {
  open: false,
  severity: '',
  title: '',
  message: '',
};

const initState = {
  loading: false,
  loadError: false,
  notFound: false,
  reportsChangeBanner: initReportsChangeBanner,
  reportId: '',
  reportDetails: {},
  topImage: null,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.LOADING_REPORTS_CHANGE_PAGE: {
      return {
        ...state,
        loading: true,
        reportsChangeBanner: initReportsChangeBanner,
      };
    }
    case types.LOAD_REPORTS_CHANGE_PAGE_SUCCESS: {
      return {
        ...state,
        reportsChangeBanner: {
          open: true,
          severity: action.severity,
          message: action.message,
        },
        loading: false,
        loadError: false,
        notFound: false,
        reportId: action.reportId,
        reportDetails: action.reportDetails,
        topImage: action.topImage,
      };
    }
    case types.LOAD_REPORTS_CHANGE_PAGE_ERROR: {
      return {
        ...state,
        reportsChangeBanner: initReportsChangeBanner,
        loading: false,
        loadError: true,
        reportId: '',
        reportDetails: {},
      };
    }
    case types.REPORTS_CHANGE_NOT_FOUND: return {
      ...state,
      notFound: true,
      loading: false,
      loadError: false,
      reportId: '',
      reportDetails: {},
    };
    case types.REPORTS_CHANGE_BAD_REQUEST: return {
      ...state,
      reportsChangeBanner: {
        open: true,
        severity: action.severity,
        message: action.message,
      },
      loading: false,
      loadError: false,
      notFound: false,
    };
    default:
      return state;
  }
};
